import { Logger } from "DVWebNodeUtils"
import { auiModules } from "../utils/promises";

export type PurchaseData = {
  pinVerification: object
  purchaseArgs: object
  reload: boolean
}

type PurchaseModule = { start: (args: object) => any, continuePurchase: (args: object) => any } | null

let purchaseModule: PurchaseModule
let purchaseData: PurchaseData

const AUI_DEPENDENCY_TIMEOUT = 60000

export enum PurchaseError {
  AUI_DEPENDENCY = 'AUI_DEPENDENCY'
}

const init = (logger: Logger) => (
  auiModules({
    moduleNames: ['A', 'purchase-video', 'dv-purchase-data-ready'],
    timeout: AUI_DEPENDENCY_TIMEOUT,
    logger,
  }).then((modules: any[] = []) => {
    const [A, purchaseVideo] = modules
    purchaseModule = purchaseVideo
    purchaseData = A && A.state('dv-purchase-data') as PurchaseData
    return { purchaseModule, purchaseData }
  })
)

type IStartPurchase = {
  options: any,
  logger: Logger
}
export const startPurchase = async ({ options, logger }: IStartPurchase): Promise<PurchaseData> => {

  if (!purchaseModule || !purchaseData) {
    await init(logger)
  }

  return new Promise<PurchaseData>((resolve, reject) => {

    if (!purchaseModule || !purchaseData) {
      reject({
        reason: PurchaseError.AUI_DEPENDENCY
      })
    }

    const purchaseOptions = {
      ...purchaseData,
      ...options,
      pinVerification: { ...purchaseData!.pinVerification, ...options.pinVerification },
      purchaseArgs: { ...purchaseData!.purchaseArgs, ...options.purchaseArgs },
    }

    logger.debug('purchaseOptions', purchaseOptions)

    const jQueryPromise = purchaseModule!.start(purchaseOptions)
    jQueryPromise.done((args: PurchaseData) => resolve(args))
    jQueryPromise.fail((args: PurchaseData) => {
      // The AUI purchase models user cancellation is done by rejecting the promise.
      // Also it has it's own error handling so we call resolve here as well instead of reject.
      resolve(args)
    })
  })
}
